import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../api/apiclient";
import { AI_AGENT_LIST } from "../../utills/constant";
import {  SYSTEM_AI_PROFILE } from "../../api/endpoints";

// Async thunk for logging in
export const getSystemAiAgentProfile = createAsyncThunk(
  "getSystemAiAgentProfile",
  async (agentName, { rejectWithValue }) => {
    console.log('agentName',agentName)
    try {
        console.log('response','comin')
      const response = await apiGet(`${SYSTEM_AI_PROFILE}${agentName}/`);
      console.log('response',response)
      if (response?.data.status === "success") {
        return AI_AGENT_LIST;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);

const NewAgenSelectorSlice = createSlice({
  name: "getSystemAiAgentProfile",
  initialState: {
    systemProfileLoading: false,
    systemProfileError: {},
    systemProfile: {}
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSystemAiAgentProfile.pending, (state) => {
        state.systemProfileLoading = true;
        state.error = null;
      })
      .addCase(getSystemAiAgentProfile.fulfilled, (state, action) => {
        state.systemProfileLoading = false;
        state.systemProfile = action.payload.data
      })
      .addCase(getSystemAiAgentProfile.rejected, (state, action) => {
        state.systemProfileLoading = false;
        state.systemProfileError = action.payload.systemProfileError;
      });
  },
});

export default NewAgenSelectorSlice.reducer;
